// extracted by extract-css-chunks-webpack-plugin
module.exports = {"upper":"ArticleTab__upper--meu-7"};